import {
  FETCH_PARTY_REQUEST,
  FETCH_PARTY_SUCCESS,
  FETCH_PARTY_FAILURE,
} from "./RelatedPartyActionTypes";
import api from "../../utils/Api";

// Headers

export const fetchRelatedPartyRequest = () => {
  return {
    type: FETCH_PARTY_REQUEST,
  };
};

export const fetchRelatedPartySuccess = (relatedPartyData) => {
  return {
    type: FETCH_PARTY_SUCCESS,
    payload: relatedPartyData,
  };
};

export const fetchRelatedPartyFailure = (error) => {
  return {
    type: FETCH_PARTY_FAILURE,
    payload: error,
  };
};

export const fetchRelatedParty = (relatedPartyId) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };

  return async (dispatch) => {
    dispatch(fetchRelatedPartyRequest);
    try {
      const response = await api.get("relatedparty/"+relatedPartyId, {
        headers: headers,
      });
      const relatedPartyData = response.data.data;
      dispatch(fetchRelatedPartySuccess(relatedPartyData));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchRelatedPartyFailure(errorMsg));
    }
  };
};
